<template>
  <span>ConfigurationView</span>
</template>

<script>
export default {
  name: "ConfigurationView",
  props: {},
  components: {},
};
</script>

<style></style>
